import Container from "@mui/material/Container";
import React, { useEffect, useState } from "react";
import CommonLayout from "../Common/Layout";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import CategoryService from "../../service/category";
import { BigTile, TextComponent } from "../Common/Tile";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";

const breadcrumbArr = [{ link: "#", displayName: "New Job", active: true }];

// Load Sub Categories on click of Category
const handleCategoryClick = (link, linkParams) => {
  linkParams.setCategoryDetails(linkParams.state);
};

const Categories = React.memo(({ categories, setCategoryDetails, addJobURL }) => {
  return categories.map((category) => (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={category.Category_id}>
      <BigTile
        style={{ minHeight: "160px", borderLeft: "10px solid #f6ca9f", marginTop: "10px" }}
        configData={{
          link: addJobURL,
          linkParams: {
            state: {
              Category_id: category.Category_id,
              CategoryName: category.Name,
              CategoryProductLink: category.ProductLink,
            },
            setCategoryDetails: setCategoryDetails,
          },
          clickEvent: handleCategoryClick,
          cursor: "pointer",
          label: (
            <>
              <img
                style={{ width: "80px", height: "80px" }}
                crossOrigin="anonymous"
                src={
                  process.env.REACT_APP_API_URL +
                  "/" +
                  (category.File ? category.File : "file/categories/NoImageAvailable.png")
                }
                alt="Category"
              />
              <br />
              <TextComponent label="Name " value={category.Name} style={{ fontSize: "14px" }} />
            </>
          ),
          description: <TextComponent label="Description " value={category.Description} style={{ fontSize: "14px" }} />,
        }}
      />
    </Grid>
  ));
});

const SubCategories = React.memo(({ subcategories, categoryDetails, addJobURL }) => {
  const navigate = useNavigate();

  return subcategories.map((subcategory) => (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={subcategory.Subcategory_id}>
      <BigTile
        style={{ minHeight: "160px", borderLeft: "10px solid #bddbaf", marginTop: "10px" }}
        configData={{
          link: addJobURL,
          linkParams: {
            state: {
              Category_id: categoryDetails.Category_id,
              CategoryName: categoryDetails.CategoryName,
              SubCategory_id: subcategory.Subcategory_id,
              SubCategoryName: subcategory.Name,
              CategoryProductLink: categoryDetails.CategoryProductLink,
            },
          },
          clickEvent: navigate,
          cursor: "pointer",
          label: (
            <>
              <img
                style={{ width: "80px", height: "80px" }}
                crossOrigin="anonymous"
                src={
                  process.env.REACT_APP_API_URL +
                  "/" +
                  (subcategory.File ? subcategory.File : "file/subcategories/NoImageAvailable.png")
                }
                alt="Sub Category"
              />
              <br />
              <TextComponent label="Name " value={subcategory.Name} style={{ fontSize: "14px" }} />
            </>
          ),
          description: (
            <TextComponent label="Description " value={subcategory.Description} style={{ fontSize: "14px" }} />
          ),
        }}
      />
    </Grid>
  ));
});

const NewJob = () => {
  const { user } = useSelector((state) => state);
  const addJobURL = user.currentUser.isAdminOrEmp === 1 ? "/admin/add-job" : "/add-job";
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const [categoryDetails, setCategoryDetails] = useState({
    Category_id: 0,
    CategoryName: "",
    CategoryProductLink: 1,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const categoryService = new CategoryService();

    categoryService.getAllCategories({ Status: 1 }).then((response) => {
      if (response.success) setCategories(response.data.categoryList);
    });
  }, []);

  useEffect(() => {
    if (categoryDetails.Category_id) {
      const categoryService = new CategoryService();

      categoryService.getSubcategoriesByCategoryId(categoryDetails.Category_id).then((response) => {
        if (response.success) {
          if (response.data.length) setSubcategories(response.data);
          else {
            // Redirect to job details page, if Sub Categories not available
            navigate(addJobURL, {
              state: {
                Category_id: categoryDetails.Category_id,
                CategoryName: categoryDetails.CategoryName,
                CategoryProductLink: categoryDetails.CategoryProductLink,
              },
            });
          }
        }
      });
    }
  }, [categoryDetails]);

  return (
    <CommonLayout title="New Job" breadcrumbArr={breadcrumbArr}>
      <Container maxWidth="false" sx={{ mt: 4, mb: 4, mx: 0 }}>
        {categoryDetails.Category_id !== 0 && (
          <Button
            variant="contained"
            sx={{ mb: 2 }}
            style={{ backgroundColor: "#3a3d4a" }}
            onClick={() => {
              setCategoryDetails({ Category_id: 0, CategoryName: "", CategoryProductLink: 1 });
              setSubcategories([]);
            }}
          >
            Back
          </Button>
        )}
        <Box>
          {categoryDetails.Category_id === 0 ? (
            <>
              <Typography style={{ fontSize: "16px", fontWeight: "bold", display: "block" }}>
                Select Categories
              </Typography>
              <Grid container spacing={3}>
                <Categories categories={categories} setCategoryDetails={setCategoryDetails} addJobURL={addJobURL} />
              </Grid>
            </>
          ) : (
            <>
              <Typography style={{ fontSize: "16px", fontWeight: "bold", display: "block" }}>
                Select Subcategories
              </Typography>
              <Grid container spacing={3}>
                <SubCategories subcategories={subcategories} categoryDetails={categoryDetails} addJobURL={addJobURL} />
              </Grid>
            </>
          )}
        </Box>
      </Container>
    </CommonLayout>
  );
};

export default NewJob;
